var map = {
	"./": 6550,
	"./en": 9010,
	"./en.ts": 9010,
	"./i18n": 4713,
	"./i18n.ts": 4713,
	"./index": 6550,
	"./index.ts": 6550,
	"./pt": 8216,
	"./pt.ts": 8216
};

function webpackAsyncContext(req) {
	return Promise.resolve().then(() => {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}

		var id = map[req];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 4051;
module.exports = webpackAsyncContext;